// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3PLjK","buttons":"styles_buttons__CDCzc"};